<script setup>
import VueScrollTo from "vue-scrollto";
import {onMounted, ref, watch} from "vue";
import CloseSvg from "@svg/new-close.svg";

const props = defineProps({
    transcript: Array,
    currentSeconds: Number
})

const mouseOver = ref(false)
const lastSegmentSeconds = ref(0)

const scrollToSegment = (seconds) => {
    if (typeof props.transcript.find(s => s.start === seconds) === 'undefined') {
        return
    }

    if (seconds === lastSegmentSeconds.value) {
        return
    }

    lastSegmentSeconds.value = seconds

    VueScrollTo.scrollTo(`#segment-${seconds}`, {
        container: '#transcript',
        offset: -100,
        duration: 0
    })
}

onMounted(() => {
    watch(() => props.currentSeconds, (seconds) => {
        if (mouseOver.value === true) {
            return
        }

        scrollToSegment(seconds)
    })
})

const emit = defineEmits()
</script>

<template>
    <div class="bg-[rgba(20,22,57,1)] px-6 py-5 md:p-10 rounded-2xl">
        <div class="flex items-center justify-between">
            <h2 class="text-xl text-[rgba(243,251,2551)] font-semibold leading-none">
                Transcript
            </h2>

            <button class="size-6 flex items-center justify-center touch-manipulation" v-on:click="emit('close')">
                <CloseSvg class="size-6 text-[rgba(132,156,241,1)] touch-manipulation" />
            </button>
        </div>

        <div
            class="overflow-y-scroll scroll-smooth h-80 mt-6 space-y-2 pr-2"
            id="transcript"
            v-on:mouseover="mouseOver = true"
            v-on:mouseleave="mouseOver = false; scrollToSegment(lastSegmentSeconds)"
        >
            <div
                v-for="segment in transcript"
                :id="`segment-${segment.start}`"
                :key="segment.start"
                class="transition-all"
                :class="{
                    'ml-1': currentSeconds >= segment.start && currentSeconds < segment.end
                }"
            >
                <div
                    v-on:click="emit('timeupdate', segment.start)"
                    class="cursor-pointer bg-[rgba(27,32,74,1)] text-[rgba(148,162,209,1)] w-full p-4 text-sm flex items-start rounded-lg"
                    :class="{
                        'bg-gradient-to-r from-[rgba(54,47,150,1)] to-[rgba(54,47,150,1)]': currentSeconds >= segment.start && currentSeconds < segment.end
                    }"
                >
                    <div
                        class="text-[rgba(112,120,176,1)] w-14 shrink-0"
                        :class="{
                            'text-[rgba(148,162,209,1)]': currentSeconds >= segment.start && currentSeconds < segment.end
                        }"
                    >
                        {{ segment.seconds }}
                    </div>
                    <div
                        :class="{
                            'text-[rgba(169,198,249,1)]': currentSeconds >= segment.start && currentSeconds < segment.end
                        }"
                    >
                        {{ segment.text }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
